import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
//import notifikasi from "./notifikasi";
import role from "./role";
//import setting from "./setting";
import user from "./user";
import contact from "./contact";
import register from "./register";
import daftar from "./daftar";

export default combineReducers({
  auth,
  message,
  role,
  user,
  contact,
  register,
  daftar,
});
